module.exports = __webpack_public_path__ + "static/img/bigEwm3.4c2dc1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/bigEwm3.png
// module id = pI/W
// module chunks = 0